module.exports = __webpack_public_path__ + "img/tenebris2.2bef9c9e.png";